var exports = {
  "g4": "AuthPageStyles.module__loadingContainer___WWZ1VW",
  "Un": "AuthPageStyles.module__errorContainer___WWZ1VW",
  "ik": "AuthPageStyles.module__errorIcon___WWZ1VW",
  "gi": "AuthPageStyles.module__errorIconSvg___WWZ1VW",
  "JU": "AuthPageStyles.module__errorTitle___WWZ1VW",
  "kc": "AuthPageStyles.module__errorText___WWZ1VW",
  "kL": "AuthPageStyles.module__container___WWZ1VW",
  "zm": "AuthPageStyles.module__loginHeader___WWZ1VW",
  "TQ": "AuthPageStyles.module__entityHeader___WWZ1VW",
  "Ep": "AuthPageStyles.module__entityDetails___WWZ1VW",
  "Pp": "AuthPageStyles.module__entityText___WWZ1VW",
  "j2": "AuthPageStyles.module__entityTitleWrapper___WWZ1VW",
  "wD": "AuthPageStyles.module__entityTitle___WWZ1VW",
  "N2": "AuthPageStyles.module__entityStats___WWZ1VW",
  "So": "AuthPageStyles.module__entityStat___WWZ1VW",
  "RS": "AuthPageStyles.module__onlineDot___WWZ1VW",
  "FD": "AuthPageStyles.module__offlineDot___WWZ1VW",
  "KA": "AuthPageStyles.module__statText___WWZ1VW",
  "Wp": "AuthPageStyles.module__entityIconWrapper___WWZ1VW",
  "fq": "AuthPageStyles.module__entityIcon___WWZ1VW",
  "Ly": "AuthPageStyles.module__themeIconSpot___WWZ1VW",
  "J3": "AuthPageStyles.module__themeIcon___WWZ1VW",
  "Zd": "AuthPageStyles.module__form___WWZ1VW",
  "ee": "AuthPageStyles.module__registrationNotice___WWZ1VW",
  "Gr": "AuthPageStyles.module__bottomLink___WWZ1VW",
  "fH": "AuthPageStyles.module__bottomLinkText___WWZ1VW",
  "J5": "AuthPageStyles.module__bottomLinkAnchor___WWZ1VW",
  "cB": "AuthPageStyles.module__usernameHint___WWZ1VW",
  "Jy": "AuthPageStyles.module__suggestionLink___WWZ1VW",
  "LB": "AuthPageStyles.module__usernameError___WWZ1VW",
  "up": "AuthPageStyles.module__legalNotice___WWZ1VW",
  "Rf": "AuthPageStyles.module__policyLink___WWZ1VW",
  "ii": "AuthPageStyles.module__disabledContainer___WWZ1VW",
  "aV": "AuthPageStyles.module__disabledText___WWZ1VW",
  "ax": "AuthPageStyles.module__disabledSubtext___WWZ1VW",
  "SO": "AuthPageStyles.module__disabledActions___WWZ1VW",
  "ns": "AuthPageStyles.module__disabledActionLink___WWZ1VW",
  "DD": "AuthPageStyles.module__title___WWZ1VW",
  "Zo": "AuthPageStyles.module__giftIconContainer___WWZ1VW",
  "ez": "AuthPageStyles.module__giftIcon___WWZ1VW",
  "PM": "AuthPageStyles.module__entitySubtext___WWZ1VW",
  "W$": "AuthPageStyles.module__subtext___WWZ1VW",
  "$0": "AuthPageStyles.module__consentLine___WWZ1VW",
};

module.exports = exports;
